import { OrderingParam, SortKey } from '../CustomersV2.types';

/**
 * Computes the next `ordering` value for a header sort cycle: ascending →
 * descending → default. `null` means "no explicit sort" — the caller falls back
 * to `defaultSort`. Clicking a different column always restarts at ascending.
 *
 * The column named by `defaultSort` has only two states, since one of its
 * directions is the default itself.
 */
export function nextSort(
  sortKey: SortKey,
  explicitSort: OrderingParam | null,
  defaultSort: OrderingParam,
): OrderingParam | null {
  const effectiveSort = explicitSort ?? defaultSort;
  const descendingIsDefault = `-${sortKey}` === defaultSort;

  if (effectiveSort === sortKey) {
    return descendingIsDefault ? null : `-${sortKey}`;
  }
  if (effectiveSort === `-${sortKey}`) {
    return descendingIsDefault ? sortKey : null;
  }
  return sortKey;
}
